import { Component, ElementRef, OnInit } from "@angular/core";

import { ActivatedRoute, Router } from "@angular/router";

import { NotificationService } from "src/app/Service/notification.service";

import { OtherService } from "src/app/Service/other.service";

import Chart from 'chart.js/auto';

import axios from "src/app/Service/axios";

import { Location } from '@angular/common';

import Map from 'ol/Map';

import View from 'ol/View';

import * as olProj from 'ol/proj';

import {

  DragRotateAndZoom,

  defaults as defaultInteractions,

} from 'ol/interaction';


import Feature from 'ol/Feature';

import { Tile as TileLayer } from 'ol/layer';

import OSM from 'ol/source/OSM';

import { Point } from "ol/geom";

import { BingMaps, Cluster, Vector, XYZ } from "ol/source";

import AnimatedCluster from "ol-ext/layer/AnimatedCluster";

import SelectCluster from "ol-ext/interaction/SelectCluster";

import { Tile } from "ol/layer";

import { MapService } from "src/app/Service/map.service";

import { DeviceDetectorService } from "ngx-device-detector";

import { Circle, Fill, Icon, Stroke, Style, Text } from "ol/style";

import "ol/ol.css";

import * as XLSX from 'xlsx';

import zoomPlugin from 'chartjs-plugin-zoom';

import { getRelativePosition } from 'chart.js/helpers';

import { FormBuilder, FormControl, FormGroup, NgForm } from "@angular/forms";

import { DataService } from "src/app/Service/data.service";

import { Observable, interval, map, startWith } from "rxjs";

import VectorSource from "ol/source/Vector";

import VectorLayer from "ol/layer/Vector";

import { animate, state, style, transition, trigger } from '@angular/animations';

import { GurdServiceService } from "src/app/Service/gurd-service.service";

declare let $: any;

@Component({

  selector: 'app-real-time-dashboard',

  templateUrl: './real-time-dashboard.component.html',

  styleUrls: ['./real-time-dashboard.component.css'],

  animations: [

    trigger('fadeAnimation', [

      state('void', style({ opacity: 0 })),

      transition(':enter', [

        animate('300ms ease-in', style({ opacity: 1 }))

      ]),

      transition(':leave', [

        animate('100ms ease-out', style({ opacity: 0 }))

      ])

    ])

  ]

})

export class RealTimeDashboardComponent implements OnInit {

  list_Schools: any = [];

  iMobileDomain: string = '-1';

  VehicleStatus: any;

  StudentStatus: any;

  CHART_COLORS3: any = {
    green: 'rgb(111, 255, 111)',
    purple: 'rgb(255, 153, 204)',
    blue: 'rgb(29, 179, 214)',
    orange: 'rgb(45, 103, 103)',
    yellow: 'rgb(251, 101, 150)',
    red: 'rgb(36, 123, 46)',
    grey: 'rgb(103, 13, 183)',
  };

  filteredItems = [];

  searchText = '';

  studentMap: any;

  driversMap: any;

  source: any;

  source2: any;

  vector: any;

  vector2: any;

  layers: any = [];

  layers2: any = [];

  private bOfflineMap: boolean = (<any>window).bOfflineMap;

  private strMapUrl: string = (<any>window).strMapUrl;

  studentData: any = [];

  carStatusData: any;

  constructor(

    private router: Router,

    private Notification: NotificationService,

    private FormBuilder: FormBuilder,

    private mapService: MapService,

    private otherService: OtherService,

    private gurdService: GurdServiceService

  ) { }

  ngOnInit(): void {

    this.getSchool();

    this.getCharts(this.iMobileDomain);

    interval(1000 * 60).subscribe(() => this.getCharts(this.iMobileDomain))

  }

  filterItems() {

    if (this.searchText == '') this.filteredItems = []

    else this.filteredItems = this.list_Schools.filter((item: any) => item.strComment.includes(this.searchText));
  }

  goBack() {

    this.router.navigateByUrl('')

  }

  onSchool_change(item: any) {

    this.searchText = item.strComment;

    this.filteredItems = []

    this.iMobileDomain = item.iMobileDomain;

    this.getCharts(item.iMobileDomain);


  }

  formatted_pelak(strVehicle: any) {

    return `ایران ${strVehicle.split(' ')[4]} | ${strVehicle.split(' ')[2]} ${strVehicle.split(' ')[1]} ${strVehicle.split(' ')[0]}`;

  }

  async getSchool() {

    var model = {

      iSystemUser: this.gurdService.decrypt(localStorage.getItem('ID')!),

      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),

    }

    let res = JSON.parse((await axios.post(`School_User_List`, model)).data.toString());

    this.list_Schools = res;

  }

  async getCharts(iMobileDomain: any) {

    var model = {

      iSystemUser: this.gurdService.decrypt(localStorage.getItem('ID')!),

      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),

      iMobileDomain: iMobileDomain

    }

    this.getVehicleStatus(model);

    this.getStudentStatus(model);

    this.School_MobileCluster(model);

    this.School_StudentCluster(model);

  }

  async getVehicleStatus(model: any) {

    let res = JSON.parse(((await axios.post(`School_Dashboard_VehicleStatus`, model)).data.toString()));

    let label: Array<any> = [];

    let datachart: Array<any> = [];

    res.forEach((element: any) => {

      label.push(element.X);

      datachart.push(element.Y);

    });

    var canvas = document.getElementById("myChart1") as any;

    var ctx = canvas.getContext("2d");

    const data = {

      labels: label,

      datasets: [

        {
          data: datachart,

          backgroundColor: Object.values(this.CHART_COLORS3),

        },

      ],

    } as any;

    if (this.VehicleStatus) this.VehicleStatus.destroy();

    this.VehicleStatus = new Chart(ctx, {

      type: 'pie',

      data: data,

      options: {

        onClick: (e) => {

          const points = this.VehicleStatus.getElementsAtEventForMode(e, 'nearest', { intersect: true }, true);

          const firstPoint = points[0];

          const label = this.VehicleStatus.data.labels[firstPoint.index];

          this.carStatus(1, label)

        },

        responsive: true,
        interaction: {
          mode: 'nearest',
          intersect: false
        },

        plugins: {

          legend: {

            position: 'top',

            labels: {

              color: "black",

            }

          },

          title: {

            display: false,

          },

        },

      },

    });

    var chartEl = document.getElementById("myChart1") as any;

    chartEl.height = 200;
  }

  async getStudentStatus(model: any) {

    let res = JSON.parse(((await axios.post(`School_Dashboard_StudentsStatus`, model)).data.toString()));

    let label: Array<any> = [];

    let datachart: Array<any> = [];

    res.forEach((element: any) => {

      label.push(element.X);

      datachart.push(element.Y);

    });

    var canvas = document.getElementById("myChart2") as any;

    var ctx = canvas.getContext("2d");

    const data = {

      labels: label,

      datasets: [

        {
          data: datachart,

          backgroundColor: Object.values(this.CHART_COLORS3),

        },

      ],

    } as any;

    if (this.StudentStatus) this.StudentStatus.destroy();

    this.StudentStatus = new Chart(ctx, {

      type: 'pie',

      data: data,

      options: {

        onClick: (e) => {

          const points = this.StudentStatus.getElementsAtEventForMode(e, 'nearest', { intersect: true }, true);

          const firstPoint = points[0];

          const label = this.StudentStatus.data.labels[firstPoint.index];

          this.studentStatus(1, label)

        },
        responsive: true,
        interaction: {
          mode: 'nearest',
          intersect: false
        },

        plugins: {

          legend: {

            position: 'top',

            labels: {

              color: "black",

            }

          },

          title: {

            display: false,

          },

        },

      },

    });

    var chartEl = document.getElementById("myChart2") as any;

    chartEl.height = 200;

  }

  async School_MobileCluster(model: any) {

    let res = JSON.parse(((await axios.post(`School_Dashboard_MobileCluster`, model)).data.toString()));

    setTimeout(() => {

      if (this.driversMap) this.driversMap.setTarget(null);

      this.source = new VectorSource({ wrapX: false });

      this.vector = new VectorLayer({

        source: this.source,

      });

      if (this.bOfflineMap) {

        this.layers.push(

          new TileLayer({

            source: new XYZ({

              url: this.strMapUrl,

              attributions: 'Map data © RayanAndishehNasr' // 

            }),

          })

        );
      }

      else {

        const styles = [

          'AerialWithLabelsOnDemand',

        ];

        let i, ii;

        for (i = 0, ii = styles.length; i < ii; ++i) {
          this.layers.push(
            new TileLayer({
              visible: false,
              preload: Infinity,
              source: new BingMaps({
                key: 'Ap0AObt84NcDaUThCeWOj52ZqUHv6k4TJhjLibR-DghC-semgoj-0uPbIi8r0E4j',

                imagerySet: styles[i],
              }),

            }),
          );
        }

        this.layers.push(new TileLayer({ source: new OSM({}) }), this.vector)
      }

      this.driversMap = new Map({

        target: "map2",

        view: new View({

          zoom: 4,

          center: olProj.fromLonLat([51.3833554, 35.6770113])

        }),

        layers: this.layers

      });

      res.forEach((point: any) => {

        let iconSrc;

        if (point.tiOfficialStatus == 0) iconSrc = '../../assets/Img/redBus.png';

        else if (point.tiOfficialStatus == 1) iconSrc = '../../assets/Img/greenBus.png';

        else iconSrc = '../../assets/Img/blueBus.png';

        const iconStyle = new Style({

          image: new Icon({

            src: iconSrc,

            size: [40, 38],

            anchor: [0.5, 1],

          }),

        });

        const marker = new Feature({ geometry: new Point(olProj.fromLonLat([point.dLongitude, point.dLatitude])) });

        marker.setStyle(iconStyle);

        const vectorSource = new VectorSource({ features: [marker] });

        const vectorLayer = new VectorLayer({ source: vectorSource });

        marker.set('busData', point)

        this.driversMap.addLayer(vectorLayer);



      });

      this.driversMap.on('click', (e: any) => {

        if (e.dragging) return

        var el = this.mapService.mapPointerMove(

          this.driversMap.getEventPixel(e.originalEvent),

          this.driversMap

        );

        var data = el.featureLayer.feature.values_.busData;

        const strVehicleNo = data.strVehicleNo.split(' ');

        data.strVehicleNo = ' ایران ' + (strVehicleNo[4]) + '  |  ' + strVehicleNo[2] + ' ' + strVehicleNo[1] + ' ' + strVehicleNo[0];

        this.Notification.showInfo(` پلاک : ${data.strVehicleNo} `, `نام راننده : ${data.strFullName}`)

        // console.log(el.featureLayer.feature.values_.busData)

      });

    }, 500);

  }

  async School_StudentCluster(model: any) {

    let res = JSON.parse(((await axios.post(`School_StudentCluster`, model)).data.toString()));

    setTimeout(() => {

      if (this.studentMap) this.studentMap.setTarget(null);

      this.source2 = new VectorSource({ wrapX: false });

      this.vector = new VectorLayer({

        source: this.source2,

      });

      if (this.bOfflineMap) {

        this.layers2.push(

          new TileLayer({

            source: new XYZ({

              url: this.strMapUrl,

              attributions: 'Map data © RayanAndishehNasr' // 

            }),

          })

        );
      }

      else {

        const styles = [

          'AerialWithLabelsOnDemand',

        ];

        let i, ii;

        for (i = 0, ii = styles.length; i < ii; ++i) {
          this.layers2.push(
            new TileLayer({
              visible: false,
              preload: Infinity,
              source: new BingMaps({
                key: 'Ap0AObt84NcDaUThCeWOj52ZqUHv6k4TJhjLibR-DghC-semgoj-0uPbIi8r0E4j',

                imagerySet: styles[i],
              }),

            }),
          );
        }

        this.layers2.push(new TileLayer({ source: new OSM({}) }), this.vector2)
      }

      this.studentMap = new Map({

        target: "map1",

        view: new View({

          zoom: 4,

          center: olProj.fromLonLat([51.3833554, 35.6770113])

        }),

        layers: this.layers2

      });

      // console.log(res)

      // {
      //   dLatitude: 35.70542526245117,
      //   dLongitude: 51.400062561035156,
      //   strPassenger_FullName: 'تن ذذذر',
      //   strMobileDomain_strComment: 'شهرداری انزلی',
      //   strMobile: '0912589658 '
      // },

      // console.log(model)

      // {
      //   iSystemUser: '2668',
      //   strSession: 'AR21gr1t7aOtQV7haV4JjRmMLw+h6lXObIBebrKnRf0reTWWknBcYFpc2OaIZBs5VBvOIGq0QQU=',
      //   iMobileDomain: '-1'
      // }

      this.clustersLayer(res, model);

    }, 500);

  }

  async clustersLayer(data: any, model: []) {

    setTimeout(() => {

      this.studentMap.on('click', (e: any) => {

        if (e.dragging) return

        var el = this.mapService.mapPointerMove(
          this.studentMap.getEventPixel(e.originalEvent),
          this.studentMap
        );

        if (el.featureLayer && el.featureLayer.feature.values_.features.length == 1) this.showDetail(el.featureLayer.feature.values_.features[0].values_.data.strMobile, model)

        $("#link").click(() => {
          var tooltip = $('#map_tooltip');
          tooltip.tooltip('hide');

        });
      });
      this.studentMap.getView().on('propertychange', function (e: any) {
        var tooltip = $('#map_tooltip');
        tooltip.tooltip('hide');
      });
    }, 200);
    // Cluster Source
    var clusterSource = new Cluster({
      distance: 40,
      source: new Vector()
    }) as any;


    let addFeatures = (nb: any) => {
      var ext = this.studentMap.getView().calculateExtent(this.studentMap.getSize());
      var features = [];

      for (var i = 0; i < data.length; ++i) {
        features[i] = new Feature({
          type: 'removable',
          geometry: new Point(this.mapService.transformCoordinates2([
            data[i].dLongitude,
            data[i].dLatitude])

          ),
          id_: data[i].strUnitId,
          data: {
            strMobile: data[i].strMobile,
            strMobileDomain_strComment: data[i].strMobileDomain_strComment,
            strPassenger_FullName: data[i].strPassenger_FullName,
          },

        });

        features[i].set("id", i);
      }
      clusterSource.getSource().clear();

      clusterSource.getSource().addFeatures(features);


    }

    // Style for the clusters
    var styleCache = {} as any;
    function getStyle(feature: any, resolution: any) {
      var size = feature.get("features").length;
      var style = styleCache[size];
      if (!style) {
        var color = size > 25 ? "192,0,0" : size > 8 ? "255,128,0" : "0,128,0";
        var radius = Math.max(8, Math.min(size * 0.75, 20));
        var dash = (2 * Math.PI * radius) / 6;
        var dashs = [0, dash, dash, dash, dash, dash, dash];
        style = styleCache[size] = new Style({
          image: new Circle({
            radius: radius,
            stroke: new Stroke({
              color: "rgba(" + color + ",0.5)",
              width: 15,
              lineDash: dashs,
              lineCap: "butt"
            }),
            fill: new Fill({
              color: "rgba(" + color + ",1)"
            })
          }),
          text: new Text({
            text: size.toString(),
            fill: new Fill({
              color: "#fff"
            })
          })
        });
      }
      return style;
    }

    // Animated cluster layer
    var clusterLayer = new AnimatedCluster({
      //name: "Cluster",
      source: clusterSource,
      animationDuration: 700,
      // Cluster style
      style: getStyle
    });
    this.studentMap.addLayer(clusterLayer);
    // add 2000 features
    addFeatures(2000);

    var style1 = new Style({
      image: new Circle({
        radius: 5,
        stroke: new Stroke({
          color: "rgba(128,0,0,0.8)",
          width: 2
        }),
        fill: new Fill({
          color: "rgba(128,0,0,0.8)"
        })
      }),
      // Draw a link beetween points (or not)
      stroke: new Stroke({
        color: "#fff",
        width: 1
      })
    });
    // Select interaction to spread cluster out and select features
    var selectCluster = new SelectCluster({
      // Point radius: to calculate distance between the features
      pointRadius: 7,
      animate: true,
      // Feature style when it springs apart
      featureStyle: function () {
        return [style1];
      },
      // selectCluster: false,	// disable cluster selection
      // Style to draw cluster when selected
      style: function (f, res) {
        var cluster = f.get("features");
        if (cluster.length > 1) {
          return getStyle(f, res);
        } else {
          return [
            new Style({
              image: new Circle({
                stroke: new Stroke({
                  color: "rgba(0,0,192,0.5)",
                  width: 2
                }),
                fill: new Fill({ color: "rgba(0,0,192,0.3)" }),
                radius: 5
              })
            })
          ];
        }
      }
    });
    this.studentMap.addInteraction(selectCluster);


  }

  async showDetail(strMobile: string | number, model: any) {

    model.strMobile = strMobile;

    model.strFullName = '';

    model.tiSex = -1;

    let res = JSON.parse((await axios.post(`School_Passenger_List`, model)).data.toString());

    this.studentData = res[0];

    $('#detailModal').modal('show');


  }

  async carStatus(tiChart: any, strValue: any) {

    this.otherService.Showspinner();

    var model = {

      iSystemUser: this.gurdService.decrypt(localStorage.getItem("ID")!),

      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),

      tiChart: tiChart,

      strValue: strValue

    }

    let res = JSON.parse(((await axios.post(`School_GetMobileListBaseChartStatus `, model)).data.toString()));

    this.otherService.nonespinner();

    this.carStatusData = res;

    $('#CarStatusModal').modal('show');


  }

  async studentStatus(tiChart: any, strValue: any) {

    this.otherService.Showspinner();

    var model = {

      iSystemUser: this.gurdService.decrypt(localStorage.getItem("ID")!),

      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),

      tiChart: tiChart,

      strValue: strValue

    }

    let res = JSON.parse(((await axios.post(`GetPassengerListBaseChartStatus `, model)).data.toString()));

    this.otherService.nonespinner();

    // todo console.log(res)

    // todo this.carStatusData = res;

    // todo $('#CarStatusModal').modal('show');


  }

}
